import React, { useState } from "react";
import { FormControlLabel, Checkbox, Box } from "@mui/material";

const AgreementCheckboxField = ({
  schema,
  idSchema,
  formData,
  onChange,
  rawErrors = [],
    uiSchema = {},

}) => {
  const { title, description } = schema;
  const uiDescription = uiSchema["ui:description"]; 
  const fieldId = idSchema.$id;

  const [touched, setTouched] = useState(false);

  const handleChange = (event) => {
    const checked = event.target.checked;

    onChange(checked ? true : undefined);
    setTouched(true);
  };

  return (
    <Box mb={0}>
      {description && (
        <Box mt={1} mb={1}>
          {typeof description === "string" ? <div>{description}</div> : description}
        </Box>
      )}

      {!description && uiDescription && (
        <Box mt={1} mb={1}>
            {uiDescription}
        </Box>
      )}
      <FormControlLabel
        control={
          <Checkbox
            id={fieldId}
            checked={formData === true} 
            onChange={handleChange}
            onBlur={() => setTouched(true)}
          />
        }
        label={title}
      />
    </Box>
  );
};

export default AgreementCheckboxField;
